import React from 'react';
import NewsletterAbout from 'components/media/newletter/newletterlist';
import NewsletterBanner from 'components/media/newletter/newletterBanner';
import LazySection from 'components/lazySection';
import SectionSkeleton from './sectionskeleton';
const NewsLetter: React.FC = () => {
  return (
    <>
      <NewsletterBanner />
        <LazySection fallback={<SectionSkeleton height={300} />}>
        <NewsletterAbout />
      </LazySection> 
    
    </>
  );
};

export default NewsLetter;
